import {getUsername} from '../../../_shared/GWTBridge/invoke/genPage';
import {getStorageItem, setStorageItem} from '../../../services/storageService';
import {formsStore} from '../../../_legacy/Form/stores/FormsStore';
import {getCompanyName} from '../../../utils/proto-api-utils/utils';

/**
 UserPrevIndexed = {
    [userName_company]: {
        [zoomFname]: [entityIds]
    }
 } 
*/

export const PREV_INDEXED_KEY = 'moreInfoPrevIndexed';

const toBase64 = (data: string) => Buffer.from(data).toString('base64');

const fromBase64 = (data: string) => Buffer.from(data, 'base64').toString();

const getServerPrevIndexed = async () => {
    try {
        const serverPrevIndexed = await getStorageItem(PREV_INDEXED_KEY);
        const {moreInfoPrevIndexed} = serverPrevIndexed;
        return moreInfoPrevIndexed ? JSON.parse(fromBase64(moreInfoPrevIndexed)) : null;
    } catch (err) {
        console.error(
            'An error occured while getting Personalization MoreDetails PrevIndexed:',
            err
        );
    }
};

export const getUserPIFromServer = async () => {
    try {
        const serverPrevIndexed = await getServerPrevIndexed();
        const userName = getUsername();
        const company = getCompanyName();
        const userPrevIndexed = serverPrevIndexed && serverPrevIndexed[`${userName}_${company}`];
        return userPrevIndexed;
    } catch (err) {
        console.error(
            'An error occured while getting User Personalization MoreDetails PrevIndexed:',
            err
        );
    }
};

const savePrevIndexed = async data => {
    try {
        const encodedData = toBase64(JSON.stringify(data));
        await setStorageItem(PREV_INDEXED_KEY, JSON.stringify(encodedData));
    } catch (err) {
        console.error(
            'An error occured while updating Personalization MoreDetails PrevIndexed',
            err
        );
    }
};

const updatePrevIndexed = async (
    serverPrevIndexed,
    collectionPeriodData,
    userName: string,
    company: string
) => {
    const prevIndexedCopy = {...serverPrevIndexed};
    const userPrevIndexed = prevIndexedCopy[`${userName}_${company}`];

    if (!userPrevIndexed) {
        prevIndexedCopy[`${userName}_${company}`] = collectionPeriodData;
        savePrevIndexed(prevIndexedCopy);
    } else {
        const prevIndexedKeys = Object.keys(userPrevIndexed);
        const updatedUserData = prevIndexedKeys.map(key => {
            const serevrScreenForms = userPrevIndexed[key];
            const entityIds = serevrScreenForms.map(form => form.entityId);

            collectionPeriodData[key].forEach(screen => {
                if (!entityIds.includes(screen.entityId)) {
                    serevrScreenForms.push(screen);
                }
            });
            return {key: serevrScreenForms};
        });
        const updatedPrevIndexed = {
            [`${userName}_${company}`]: updatedUserData,
            ...prevIndexedCopy
        };
        savePrevIndexed(updatedPrevIndexed);
    }
};

export const updateUserPrevIndexed = async collectionPeriodData => {
    const serverPrevIndexed = await getServerPrevIndexed();
    const userName = getUsername();
    const company = getCompanyName();

    if (!serverPrevIndexed) {
        const data = {
            [`${userName}_${company}`]: collectionPeriodData
        };
        await savePrevIndexed(data);
    } else {
        await updatePrevIndexed(serverPrevIndexed, collectionPeriodData, userName, company);
    }
};

export const getPrevIndexedByZoomFname = async (zoomFname: string) => {
    const serverPrevIndexed = await getServerPrevIndexed();
    const userName = getUsername();
    const company = getCompanyName();
    if (serverPrevIndexed) {
        const userPrevIndexed = serverPrevIndexed[`${userName}_${company}`];
        if (userPrevIndexed) {
            const prevIndexedByZoomFname = userPrevIndexed[zoomFname];
            if (prevIndexedByZoomFname) {
                formsStore.setMoreInfoPrevIndexed(
                    `${company}_${zoomFname}`,
                    prevIndexedByZoomFname
                );
                return prevIndexedByZoomFname;
            }
        }
    }
    return [];
};
